import gmx_zMixins          from '../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_Watching         from './Watching'
import lmx_Events           from './Events'


import lmx_localData        from '../primitives/localData'
import lmx_LocalValues      from './set_LocalValues'
import lmx_draw_Form        from './draw_Form'
import lmx_draw_PDF         from './draw_PDF'



export default {
  
  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_Events,
    lmx_Watching,

    lmx_localData,
    lmx_LocalValues,
    lmx_draw_Form,
    lmx_draw_PDF,

  ],

}
